jPar.util = jPar.util || {};
deepMerge(true, jPar.util, {
	pwa: {
		newServiceworkerAvailable: false,
		isOfflineSwEnabled: false,
		swListenerInit: false,

		init: function () {
			const killDefaultCache = document.querySelector('#serviceWorkerKillSwitch') !== null;
			this.isOfflineSwEnabled = document.querySelector('#offlineError') !== null;
			this.createServiceWorker();

			if (this.isOfflineSwEnabled) {
				document.addEventListener(
					'peg:newUserLogin',
					() => {
						this.killDefaultCache();
					},
					{ signal: jPar.util.getGlobalAbortSignal() },
				);

				this.startPrepareDefaultCache();
				this.lieFi.init();
				this.checkStandalone();
			} else if (killDefaultCache) {
				this.killDefaultCache();
			}
		},

		createServiceWorker: function () {
			if (navigator.serviceWorker !== undefined) {
				// && serviceworkerIsAllowed //Firefox private Mode kann keine Serviceworker. https://bugzilla.mozilla.org/show_bug.cgi?id=1320796
				// ein neuer Serviceworker ist vorhanden = release hat stattgefunden
				if (this.swListenerInit === false) {
					// navigator.serviceWorker.removeEventListener('message', this.handleSwEvents);
					navigator.serviceWorker.addEventListener('message', this.handleSwEvents);
					this.swListenerInit = true;
				}
				navigator.serviceWorker
					.register(new URL('/service-worker', import.meta.url))
					.then(
						() => {
							// console.log('sw installed');
						},
						() => {
							// console.log('Firefox: "Webseite-Daten bei Beenden von Firefox löschen" angehakt hat zwar SW, wird aber rejected'.);
						},
					)
					.catch((err) => {
						jPar.util.log.error('PWA Serviceworker:', err);
					});
			}
		},

		handleSwEvents: function (event) {
			if (event.data?.command === 'logJsError') {
				jPar.util.log.error('PWA', event.data.stacktrace);
			}
			if (event.data?.command === 'pageAnsweredFromCache') {
				// console.log('....pageAnsweredFromCache');
				document.querySelector('html').setAttribute('data-origin', 'cacheStorageAjax');
				jPar.util.pwa.lieFi.setCachedPageCount();
			}
			if (event.data?.command === 'pageAnsweredFromNetwork') {
				// console.log('....pageAnsweredFromNetwork');
				document.dispatchEvent(new CustomEvent('serviceworker:pageFromNetwork'));
			}

			/* if (event.data?.command === 'newServcieWorkerActivated') {
				console.log('neue SW ist da einmal reload');
				document.location.reload();
			}*/
		},

		hasNewServiceWorker: function () {
			if (navigator.serviceWorker !== undefined && this.isOfflineSwEnabled) {
				navigator.serviceWorker.getRegistrations().then((registrations) => {
					if (registrations.length > 0 && registrations[0].active !== null) {
						registrations[0].update();
					}
				});
			}
		},

		killServiceWorker: function () {
			if (navigator.serviceWorker !== undefined) {
				navigator.serviceWorker.getRegistrations().then(
					(registrations) => {
						if (registrations.length > 0) {
							navigator.serviceWorker.addEventListener('message', (event) => {
								if (event.data === 'killSwitchSwDeleted') {
									document.location.reload(); // Seite vom aktuellen SW befreien
								}
							});
							navigator.serviceWorker.controller.postMessage('killSwitch');
						}
					},
					() => {
						// console.log('Wegen Firefox');
					},
				);
			}
		},

		killDefaultCache: function () {
			try {
				caches
					.keys()
					.then(function (cacheNames) {
						// Alle vorhandenen Caches
						cacheNames.forEach(function (cacheName) {
							const isDefaultCache = cacheName.indexOf('defaultCache-') > -1;
							if (isDefaultCache) {
								console.log('killDefaultCache');
								caches.delete(cacheName).then(function () {
									// console.log(cacheName);
								});
							}
						});
					})
					.catch((error) => {
						jPar.util.log.error(error, 'killDefaultCaches: failed');
					});
			} catch {
				/* Firefox private Mode fails */
			}
		},

		killCaches: function () {
			caches
				.keys()
				.then(function (cacheNames) {
					// Alle vorhandenen Caches
					cacheNames.forEach(function (cacheName) {
						caches.delete(cacheName).then(function () {
							// console.log(cacheName);
						});
					});
				})
				.catch((error) => {
					jPar.util.log.error(error, 'killCaches: failed');
				});
		},

		startPrepareDefaultCache: function () {
			const isLoggedIn = document.querySelector('#domPageVars').dataset.userId !== undefined;
			const isNotCacheablePage =
				document.querySelector('peg-registration-featured-profile, #partnerCompatibilityPage, #partnerCompatibilityPage2025') === null;
			const hasRunningSw = navigator.serviceWorker !== undefined && navigator.serviceWorker.controller !== null;

			if (isLoggedIn && hasRunningSw && isNotCacheablePage) {
				navigator.serviceWorker.controller.postMessage('prepareDefaultCache');
			}
		},

		lieFi: {
			init: function () {
				this.handleCachedPageTracking();
				this.checkDomForCachedHtml();
			},

			checkDomForCachedHtml: function () {
				if (document.querySelector('html[data-origin=cacheStorage]') !== null) {
					// From PageNavigation outside of AppShell
					this.setCachedPageCount();
				}
			},

			handleCachedPageTracking: function () {
				const isLoggedIn = document.querySelector('#domPageVars').dataset.userId !== undefined && jPar.app !== undefined;
				if (isLoggedIn) {
					const dayOfSwData = jPar.app.appState.get('localStorage', 'pwa', 'dayOfSwData');
					const slowPageCurrentCount = jPar.app.appState.get('localStorage', 'pwa', 'slowPageFromCacheCount');
					const offlinePageCurrentCount = jPar.app.appState.get('localStorage', 'pwa', 'offlinePageFromCacheCount');
					if (dayOfSwData !== null && navigator.onLine === true) {
						if (parseInt(dayOfSwData) !== new Date().getDate()) {
							if (slowPageCurrentCount !== null) {
								jPar.util.log.ux(slowPageCurrentCount, 'pwa:slowPageFromCacheCount delivered last Session for this User');
								jPar.app.appState.remove('localStorage', 'pwa', 'slowPageFromCacheCount');
							}
							if (offlinePageCurrentCount !== null) {
								jPar.util.log.ux(offlinePageCurrentCount, 'pwa:offlinePageFromCacheCount delivered last Session for this User');
								jPar.app.appState.remove('localStorage', 'pwa', 'offlinePageFromCacheCount');
							}
							jPar.app.appState.remove('localStorage', 'pwa', 'dayOfSwData');
						}
					}
				}
			},

			setCachedPageCount: function () {
				if (typeof jPar.app !== 'undefined') {
					// jPar.app.sharedFeatures gibt es im Moment nicht imn ausgeloggten Bereich
					const isLoggedIn = document.querySelector('#domPageVars').dataset.userId !== undefined;
					if (isLoggedIn) {
						const isCachedAppshellPage =
							document.querySelector('peg-app-shell') !== null && document.querySelector('html[data-origin="cacheStorageAjax"]') !== null;
						const isCachedNormalPage =
							document.querySelector('peg-app-shell') !== null && document.querySelector('html[data-origin="cacheStorage"]') !== null;

						if (isCachedAppshellPage || isCachedNormalPage) {
							// prevent double tracking
							const dayOfSwData = jPar.app.appState.get('localStorage', 'pwa', 'dayOfSwData');
							if (dayOfSwData === null) {
								jPar.app.appState.set('localStorage', 'pwa', 'dayOfSwData', new Date().getDate());
							}

							if (navigator.onLine === false) {
								let currentOfflineCount = jPar.app.appState.get('localStorage', 'pwa', 'offlinePageFromCacheCount');
								if (currentOfflineCount === null) {
									currentOfflineCount = 0;
								}
								const newOfflineCount = parseInt(currentOfflineCount) + 1;
								jPar.app.appState.set('localStorage', 'pwa', 'offlinePageFromCacheCount', newOfflineCount);
							} else {
								let currentSlowCount = jPar.app.appState.get('localStorage', 'pwa', 'slowPageFromCacheCount');
								if (currentSlowCount === null) {
									currentSlowCount = 0;
								}
								const newSlowCount = parseInt(currentSlowCount) + 1;
								jPar.app.appState.set('localStorage', 'pwa', 'slowPageFromCacheCount', newSlowCount);
							}
						}
					}
				}
			},
		},

		checkStandalone: function () {
			const isInWebAppChrome = window.matchMedia('(display-mode: standalone)').matches;
			const isInWebAppiOS = window.navigator.standalone === true;

			if (isInWebAppChrome || isInWebAppiOS) {
				document.documentElement.classList.add('is-inPWA');
			}
		},
	},
});

/* pushNotification: {
	pushButton: null,
	swRegistration: null,
	isSubscribed: false,
	applicationServerPublicKey: 'BODJ54m6oemIHQUtDed1oOFAkYGr_y3XHLXQ6D3oT6b9zoNkyWaP_r_Usj6KU8OPWYG485pUoVROhp_RDxDA4bU',

	init: function init() {
		var _this = this;

		if ('serviceWorker' in navigator && 'PushManager' in window) {
			//eslint-env browser, es6

			this.pushButton = document.querySelector('.js-push-btn');
			jPar.util.log.devConsole('Service Worker and Push is supported');

			navigator.serviceWorker.register('/service-worker')
				.then(function(swReg) {
					jPar.util.log.devConsole('Service Worker is registered', swReg);

					_this.swRegistration = swReg;
					_this.initialiseUI();
				})
				.catch(function(error) {
					console.error('Service Worker Error', error);
				});
		} else {
			console.warn('Push messaging is not supported');
			_this.pushButton.textContent = 'Push Not Supported';
		}
	},

	initialiseUI: function initialiseUI() {
		var _this = this;
		_this.pushButton.addEventListener('click', function() {
			_this.pushButton.disabled = true;
			if (_this.isSubscribed) {
				_this.unsubscribeUser();
			} else {
				_this.subscribeUser();
			}
		});

		// Set the initial subscription value
		this.swRegistration.pushManager.getSubscription()
			.then(function(subscription) {
				_this.isSubscribed = subscription !== null;

				if (_this.isSubscribed) {
					jPar.util.log.devConsole('User IS subscribed.');
				} else {
					jPar.util.log.devConsole('User is NOT subscribed.');
				}

				_this.updateBtn();
			});
	},

	subscribeUser: function subscribeUser() {
		var _this = this;
		var applicationServerKey = this.urlB64ToUint8Array(this.applicationServerPublicKey);
		this.swRegistration.pushManager.subscribe({
			userVisibleOnly: true,
			applicationServerKey: applicationServerKey
		})
			.then(function(subscription) {
				jPar.util.log.devConsole('User is subscribed:', subscription);

				_this.updateSubscriptionOnServer(subscription);

				_this.isSubscribed = true;

				_this.updateBtn();
			})
			.catch(function(err) {
				jPar.util.log.devConsole('Failed to subscribe the user: ', err);
				_this.updateBtn();
			});
	},

	unsubscribeUser: function unsubscribeUser() {
		var _this = this;
		this.swRegistration.pushManager.getSubscription()
			.then(function(subscription) {
				if (subscription) {
					return subscription.unsubscribe();
				}
			})
			.catch(function(error) {
				jPar.util.log.devConsole('Error unsubscribing', error);
			})
			.then(function() {
				_this.updateSubscriptionOnServer(null);

				jPar.util.log.devConsole('User is unsubscribed.');
				_this.isSubscribed = false;

				_this.updateBtn();
			});
	},

	updateSubscriptionOnServer: function updateSubscriptionOnServer(subscription) {
		//Hier muss dann: Send subscription to application server

		var subscriptionJson = document.querySelector('.js-subscription-json');
		var subscriptionDetails =document.querySelector('.js-subscription-details');

		if (subscription) {
			subscriptionJson.textContent = JSON.stringify(subscription);
			subscriptionDetails.classList.remove('noDisplay');
		} else {
			subscriptionDetails.classList.add('noDisplay');
		}
	},

	updateBtn: function updateBtn() {
		if (Notification.permission === 'denied') {
			this.pushButton.textContent = 'Push Messaging Blocked.';
			this.pushButton.disabled = true;
			this.updateSubscriptionOnServer(null);
			return;
		}

		if (this.isSubscribed) {
			this.pushButton.textContent = 'Disable Push Messaging';
		} else {
			this.pushButton.textContent = 'Enable Push Messaging';
		}

		this.pushButton.disabled = false;
	},

	urlB64ToUint8Array: function urlB64ToUint8Array(base64String) {
		var padding = '='.repeat((4 - base64String.length % 4) % 4);
		var base64 = (base64String + padding)
			.replace(/\-/g, '+')
			.replace(/_/g, '/');

		var rawData = window.atob(base64);
		var outputArray = new Uint8Array(rawData.length);

		for (var i = 0; i < rawData.length; ++i) {
			outputArray[i] = rawData.charCodeAt(i);
		}
		return outputArray;
	}
},
*/
